module.exports = __webpack_public_path__ + "static/media/coder.eecb1456.jpg";